import { Fragment } from "react";
import classes from "../Modal.module.css";

function PopupHeader({ 
  title, 
  setOpenState, 
  hideCloseButton = false, 
  centerTitle = false,
  icon = null,  // Optional: path to icon image
  iconAlt = "", // Optional: alt text for icon
  variant = "default" // "default" | "compact" - compact has border-bottom
}) {
  const handleClose = () => {
    if (setOpenState && typeof setOpenState === "function") {
      setOpenState(false);
    }
  };

  // Build class names
  const containerClass = variant === "compact" 
    ? "popup-header-compact" 
    : `popup-header${centerTitle && hideCloseButton ? " center-title" : ""}`;
  
  const titleContainerClass = `popup-header-title-container${icon ? " with-icon" : ""}`;

  return (
    <Fragment>
      <div className={containerClass}>
        {/* Title with optional icon */}
        <div className={titleContainerClass}>
          {icon && (
            <img 
              src={icon}
              alt={iconAlt || title}
              className="popup-header-icon"
            />
          )}
          {variant === "compact" ? (
            <h3>{title}</h3>
          ) : (
            <h2 className={centerTitle ? "center-title" : ""}>
              {title}
            </h2>
          )}
        </div>

        {!hideCloseButton && (
          variant === "compact" ? (
            <button
              type="button"
              onClick={handleClose}
              className="popup-header-close-btn"
              title="Click to close"
            >
              ✕
            </button>
          ) : (
            <div className={classes.closeButtonContainer}>
              <button
                onClick={handleClose}
                className={classes.closeButton}
                title="Click to close"
              >
                ✕
              </button>
            </div>
          )
        )}
      </div>
      {/* Separator for compact variant */}
      {variant === "compact" && <div className="popup-header-separator" />}
    </Fragment>
  );
}

export default PopupHeader;
